<template>
  <div class="widget-wrap">
    <div class="block-header clearfix">
      <ul class="nav flex-column small-bar">
        <li>
          <div class="pointer small-item" @click="goMembers()" v-bind:class="{active: path_name == 'members'}">
            <i class="fa fa-users"></i>
            <span class="list-label">成員設定</span>
          </div>
        </li>
        <li class="nav-item">
          <div v-if="user.permission=='admin'" class="pointer small-item" @click="goCompany()" v-bind:class="{active: path_name == 'company'}">
            <i class="fas fa-info"></i>
            <span class="list-label">公司設定</span>
          </div>
        </li>
        <li>
          <div v-if="user.permission=='admin'" class="pointer small-item" @click="goStages()" v-bind:class="{active: path_name == 'set_stages'}">
            <i class="zmdi zmdi-widgets"></i>
            <span class="list-label">階段設定</span>
          </div>
        </li>
        <li>
          <div class="pointer small-item" @click="goActivitiesCategory()" v-bind:class="{active: path_name == 'activity_categories'}">
            <i class="far fa-calendar-plus"></i>
            <span class="list-label">任務設定</span>
          </div>
        </li>
        <li v-if="user.permission=='admin'">
          <hr>	
        </li>
        <li>
          <div v-if="user.permission=='admin'" class="pointer small-item" @click="goCreditCard()" v-bind:class="{active: path_name == 'credit_card_binding'}">
            <i class="far fa-credit-card"></i>
            <span class="list-label">方案選擇與信用卡</span>
          </div>
        </li>
        <li>
          <div v-if="user.permission=='admin'" class="pointer small-item" @click="goBills()" v-bind:class="{active: path_name == 'bills'}">
            <i class="fa fa-file-invoice-dollar"></i>
            <span class="list-label">帳單一覽</span>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  name: 'small-bar',
  data() {
    return {
      path_name: this.$route.name,
    }
  },
  created() {
    
  },
  props: ['toggle_aside','user'],
  computed: {
    
  },
  methods: {
    goCompany(){
      this.$router.push('/setting/company')
    },
    goMembers(){
      this.$router.push('/setting/members')
    },
    goStages(){
      this.$router.push('/setting/set_stages')
    },
    goActivitiesCategory(){
      this.$router.push('/setting/activity_categories')
    },
    goIssuesCategory(){
      this.$router.push('/setting/issues_categories')
    },
    goCreditCard(){
      this.$router.push('/setting/credit_card_binding')
    },
    goBills(){
      this.$router.push('/setting/bills')
    },
    goPlans(){
      this.$router.push('/setting/plans')
    },
  },
}
</script>


// WEBPACK FOOTER //
// SmallBar.vue?19dfbc61